import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14 3v2H5v14h14v-9h2v9a1.93 1.93 0 0 1-.587 1.413A1.928 1.928 0 0 1 19 21H5a1.93 1.93 0 0 1-1.413-.587A1.928 1.928 0 0 1 3 19V5c0-.55.196-1.021.587-1.413A1.928 1.928 0 0 1 5 3h9Zm5 0v2h2v2h-2v2h-2V7h-2V5h2V3h2ZM6 17h12l-3.75-5-3 4L9 13l-3 4Z" }, null, -1)
  ]))]))
}
export default { render: render }